import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { authUserSocial } from 'async/login'
import { logoutUser } from 'actions/user'

const loggedIn = (user, logoutUser) => (
    <div className="nav--logged">
      <span className="nav__name">{user.visible_name ? user.visible_name : ''}</span>
      <img className="nav__avatar" src={user.avatar} alt=""/>
      <a className="nav__logout" onClick={() => logoutUser()}>Log out</a>
    </div>
)

const loggedOut = (authUser) => (
      <a onClick={() => authUser()} className="btn btn--outline btn--sm">login with Facebook</a>
)

const Authorization = ({ user, authUser, authLogout }) => (
    <div>
      {user.logged_in ? loggedIn(user, authLogout) : loggedOut(authUser)}
    </div>
);


const AuthorizationContainer = connect(
    state => state,
    dispatch => ({
      authUser: bindActionCreators(authUserSocial, dispatch),
      authLogout: bindActionCreators(logoutUser, dispatch)
    })
)(Authorization)

export default AuthorizationContainer;


// WEBPACK FOOTER //
// ./src/containers/AuthorizationContainer.jsx